import { render, staticRenderFns } from "./PlumberOrderTemplate.vue?vue&type=template&id=7cbec43c"
import script from "./PlumberOrderTemplate.vue?vue&type=script&lang=js"
export * from "./PlumberOrderTemplate.vue?vue&type=script&lang=js"
import style0 from "./PlumberOrderTemplate.vue?vue&type=style&index=0&id=7cbec43c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports